export default __webpack_public_path__ + "static/media/bethan_furnace.15650213.png";